<template>
  <div class="app-container">
    <navigation-bar></navigation-bar>
    <div class="content-container">
      <div class="adventure-container">
        <h1>ABOUT</h1>
        <p>
          We are a team of professionals of many ages who like totravel.
          Ex-Apple, NeXT, Google, Ariba, Fandom, Shopstyle,Roadster,Facebook,
          LinkedIn, and overall serialentrepreneurs
          creating an exciting product in the Travel Industry.
          We are just getting started.
        </p>
        <button @click="joinWaitlist">Join Waitlist</button>
      </div>
      <div class="video-container">
        <video autoplay loop muted>
          <source :src="videoSource" type="video/mp4">
          Sorry, your browser does not support embedded videos.
        </video>
      </div>
    </div>
  </div>
</template>

<script>
// 导入NavigationBar组件
import NavigationBar from '../components/NavigationBar.vue';

export default {
  data() {
    return {
      // 使用require来指定视频文件的路径
      videoSource: require('@/assets/video.mp4')
    }
  },
  components: {
    // 注册NavigationBar组件
    'navigation-bar': NavigationBar
  },
  name: 'AdventureIntro',
  methods: {
    joinWaitlist() {
      // Placeholder for the logic to join the waitlist
      alert('Thank you for your interest! We will be in touch.');
    }
  }
}
</script>


<style scoped>
.app-container {
  display: flex;
  flex-direction: column;
  height: 100vh; /* 使容器填满整个视口高度 */
  background-color: black; /* 设定背景色为灰色 */
}
.content-container {
  display: flex;
  flex-direction: row; /* 确保子元素横向排列，默认值是row，通常这行不是必须的 */
  align-items: center; /* 垂直居中 */
  justify-content: center; /* 水平居中 */
  height: 100vh; /* 全视口高度 */
}

.adventure-container {
  color: #fff; /* 最好同时设置文本颜色为白色，以保证可读性 */
  width: 40%; /* 文本占据左侧40%的宽度 */
  margin-right: 5%; /* 右侧留出10%的空间，这样加上视频的50%，总共是100% */
  text-align: center;
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center; /* 垂直居中 */
}

.video-container {
  width: 45%; /* 视频占据右侧50%的宽度 */
  /* 视频容器不需要其他样式 */
}
video {
  width: 100%;
  height: auto; /* 如果你想保持视频的原始高宽比，用auto代替100% */
  object-fit: cover; /* 覆盖容器而不失去高宽比 */
}

.adventure-container h1 {
  color: #00ff66;
  font-size: 3.5rem; /* 或更大，取决于你的具体需求 */
  margin-bottom: 4.5rem; /* 标题和段落之间的间距 */
}

.adventure-container p {
  font-size: 1.25rem; /* 或更大，取决于你的具体需求 */
  margin-bottom: 1rem; /* 段落和按钮之间的间距 */
  line-height: 2.0; /* 增加行高可以改善阅读体验 */
}

.adventure-container button {
  background-color: #fa541c;
  align-self: center; /* 按钮自身居中，避免影响其他元素 */
  width: 230px;
  font-size: 1rem; /* 按钮的字体大小 */
  padding: 1rem 2rem; /* 增加按钮的内边距使其看起来更大 */
  margin-top: 1rem; /* 从上一个元素增加间隔 */
  border-radius: 15px; /* 设置边框半径为20px，增大这个值可以让按钮看起来更圆 */
}


button {
  border: none;
  color: white;
  padding: 15px 32px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  cursor: pointer;
}

button:hover {
  background-color: #45a049;
}
</style>